const { trapFocus, disableTrapFocus } = window.BAO.Utils
class SiteModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.validate()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    if (this?.externalEls?.trigger?.exists) {
      this.externalEls.trigger.elements.forEach(triggerEl => {
        this.listeners.add(triggerEl, `click`, this.handleTrigger)
      })
    }
    if (this?.els?.close?.exists) {
      this.els.close.elements.forEach(close => {
        this.listeners.add(close, `click`, this.handleClose)
      })
    }
  }

  validate () {
    if (!this.externalEls?.trigger?.exists) {
      throw new Error(`Missing trigger element`)
    }
  }

  handleTrigger (e) {
    if (e.currentTarget.dataset.siteModalKey !== this.dataset.siteModalKey) {
      return
    }

    document.body.classList.toggle('util-SiteOverflowed', true)
    this.setAttribute('aria-hidden', 'false')

    if (e.currentTarget.classList.contains('ft-Footer_Button')) {
      const contactForm = document.getElementById('ContactForm')
      const contactFormSuccess = contactForm.querySelector(
        '.frm-Form_Validation-success',
      )
      const contactFormFields = contactForm.querySelector(
        '.frm-Form_FieldsWrapper',
      )

      if (contactFormSuccess !== undefined && contactFormSuccess !== null) {
        contactFormSuccess.style.display = 'none'
      }
      if (contactFormFields !== undefined && contactFormFields !== null) {
        contactFormFields.classList.remove('frm-Form_FieldsWrapper-hidden')
      }
    }

    trapFocus(this)

    // if (this.querySelector('.mod-Modal_Close')) {
    //   window.setTimeout(
    //     () => this.querySelector('.mod-Modal_Close').focus(),
    //     300,
    //   )
    // }
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)

    disableTrapFocus()

    if (this.externalEls.trigger.exists) {
      window.setTimeout(() => this.externalEls.trigger.element.focus(), 300)
    }
  }
}

if (!customElements.get('site-modal')) {
  customElements.define('site-modal', SiteModal)
}
